// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__CNxA4","image":"styles_image__3qLgc","body":"styles_body__3TqEs"};